"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const server_1 = require("react-dom/server");
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const compose_1 = __importDefault(require("utils/compose"));
const classnames_1 = __importDefault(require("classnames"));
// MUI
const styles_1 = require("@mui/material/styles");
const react_2 = require("@emotion/react");
const mui_1 = require("tss-react/mui");
// COMPONENTS
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const Breadcrumbs_1 = __importDefault(require("containers/NewReports/components/Breadcrumbs"));
const AmountField_1 = require("components/QuickenControls/AmountField");
const styles_2 = __importDefault(require("./styles"));
const SidewaysBarChart = (0, react_1.forwardRef)(({ data, height, orderedFields, onBarClick, classes, currency }, ref) => {
    const chart = (0, react_1.useRef)(null);
    const theme = (0, styles_1.useTheme)();
    const colors = (0, react_1.useMemo)(() => theme.palette.data.sequence1.map((color) => am4core.color(color)), [theme]);
    const getLowestValue = (0, react_1.useCallback)(() => {
        var _a;
        const dataArr = Array.from(data);
        dataArr.sort((a, b) => a.total - b.total);
        let lowVal = ((_a = dataArr[0]) === null || _a === void 0 ? void 0 : _a.total) || 0;
        if (lowVal > 0) {
            lowVal = 0;
        }
        return lowVal;
    }, [data]);
    const initChart = (0, react_1.useCallback)(() => {
        am4core.options.autoDispose = true;
        const tempChart = am4core.create('sideways-bar-chart-div', am4charts.XYChart);
        tempChart.cursor = new am4charts.XYCursor();
        tempChart.cursor.lineX.disabled = true;
        tempChart.cursor.lineY.disabled = true;
        tempChart.cursor.behavior = 'none';
        tempChart.maskBullets = false;
        tempChart.zoomOutButton.disabled = true;
        const categoryAxis = tempChart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = 'category';
        categoryAxis.renderer.minGridDistance = 1;
        categoryAxis.renderer.cellStartLocation = 0;
        categoryAxis.renderer.cellEndLocation = 1;
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.inversed = true;
        categoryAxis.renderer.labels.template.fill = am4core.color(theme.palette.text.secondary);
        categoryAxis.renderer.labels.template.adapter.add('text', (_text) => '[text-transform: capitalize]{category}');
        categoryAxis.renderer.labels.template.truncate = true;
        categoryAxis.renderer.labels.template.maxWidth = 250;
        categoryAxis.cursorTooltipEnabled = false;
        categoryAxis.renderer.labels.template.marginLeft = -15;
        categoryAxis.renderer.labels.template.paddingLeft = 0;
        categoryAxis.renderer.labels.template.fontSize = 14;
        const valueAxis = tempChart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.renderer.line.strokeOpacity = 0;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.min = getLowestValue();
        valueAxis.cursorTooltipEnabled = false;
        valueAxis.padding(0, 60, 0, 0);
        const series = tempChart.series.push(new am4charts.ColumnSeries());
        series.name = 'groups';
        series.dataFields.categoryY = 'category';
        series.dataFields.valueX = 'total';
        series.sequencedInterpolation = true;
        series.columns.template.strokeWidth = 0;
        series.columns.template.height = am4core.percent(85);
        series.columns.template.maxHeight = 30;
        const cornerRadius = (sign) => (radius, item) => Math.sign(item.dataItem.dataContext[series.dataFields.valueX]) === sign ? 4 : radius;
        series.columns.template.column.adapter.add('cornerRadiusTopLeft', cornerRadius(-1));
        series.columns.template.column.adapter.add('cornerRadiusTopRight', cornerRadius(1));
        series.columns.template.column.adapter.add('cornerRadiusBottomLeft', cornerRadius(-1));
        series.columns.template.column.adapter.add('cornerRadiusBottomRight', cornerRadius(1));
        series.columns.template.adapter.add('fill', (_, target) => colors[orderedFields.indexOf(target === null || target === void 0 ? void 0 : target.dataItem.categoryY)]);
        series.columns.template.events.on('hit', (e) => {
            onBarClick === null || onBarClick === void 0 ? void 0 : onBarClick(e.target.dataItem.dataContext);
        });
        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        const columnLabels = series.bullets.push(new am4charts.LabelBullet());
        columnLabels.label.fill = am4core.color(theme.palette.text.secondary);
        columnLabels.label.truncate = false;
        columnLabels.label.hideOversized = false;
        columnLabels.label.horizontalCenter = 'left';
        columnLabels.label.textAlign = 'start';
        columnLabels.label.adapter.add('dx', (_, target) => {
            let length = 8;
            if (target.dataItem.dataContext[series.dataFields.valueX] < 0) {
                const barWidth = target.properties.maxWidth;
                length += barWidth;
            }
            return length;
        });
        columnLabels.label.adapter.add('text', (_, target) => {
            const sign = target.dataItem.dataContext[series.dataFields.valueX] < 0 ? '-' : '';
            return `${sign}$${Math.abs(target.dataItem.dataContext[series.dataFields.valueX]).toFixed(2)}`;
        });
        series.tooltip.background.strokeWidth = 0.2;
        series.tooltip.background.cornerRadius = theme.shape.borderRadius;
        series.tooltip.background.pointerLength = 0;
        series.tooltip.background.valign = 'middle';
        series.tooltip.zIndex = Infinity;
        series.tooltip.getFillFromObject = false;
        series.tooltip.background.fill = am4core.color(theme.palette.background.paper);
        series.tooltip.background.fillOpacity = 0.95;
        series.tooltip.label.padding(0, 0, 0, 0);
        series.adapter.add('tooltipHTML', (text, target) => {
            const graphData = target.tooltipDataItem.dataContext;
            if (graphData) {
                return (0, server_1.renderToStaticMarkup)(<div className={classes.sidewayTooltipWrapper}>
            <div className={classes.sidewayTooltipBullet} style={{ backgroundColor: graphData.fill }}/>
            <p className={classes.sideWayTooltipPara} id="tooltip_category">
              {graphData.category}
            </p>
            <p className={(0, classnames_1.default)(classes.sideWayTooltipPara, classes.gridRowSecond)} id="tooltip_amount">
              {(0, AmountField_1.formatNumber)(graphData.total, currency, '0,00.00')}
            </p>
          </div>);
            }
            return '';
        });
        tempChart.numberFormatter.numberFormat = '#,###.00';
        return tempChart;
    }, [orderedFields, colors, onBarClick, theme, getLowestValue, classes, currency]);
    // create the chart
    (0, react_1.useLayoutEffect)(() => {
        const constructedChart = initChart();
        chart.current = constructedChart;
        constructedChart.data = data.map((item, index) => (Object.assign({ fill: colors[index] }, item))); // for the tooltips we need to add in a fill, can be overridden by data
        return () => {
            if (constructedChart) {
                constructedChart.dispose();
            }
        };
    }, [data, orderedFields, initChart, colors]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        getGraphImage() {
            var _a, _b;
            return (_b = (_a = chart.current) === null || _a === void 0 ? void 0 : _a.exporting) === null || _b === void 0 ? void 0 : _b.getImage('png', { quality: 1, scale: 3 });
        },
    }));
    const divStyle = (0, react_1.useMemo)(() => ({ width: '100%', height: height || orderedFields.length * 28 + 30 }), [height, orderedFields]);
    return (<>
      <RendersCount_1.default id="newReportsSidewaysBarChart"/>
      <div style={{ marginTop: 20 }}>
        <Breadcrumbs_1.default />
        <div id={'sideways-bar-chart-div'} style={divStyle}/>
      </div>
    </>);
});
exports.default = (0, compose_1.default)(react_2.withTheme)((0, mui_1.withStyles)(SidewaysBarChart, styles_2.default));
